
export default {
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		crumb: {
			type: Object,
			default: () => {
			}
		}
	}
}
